export default () => ({
    metodospago: [],
    serviciosCompraCo: [],
    serviciosSenavex: [],
})
